import { useEffect, useState } from "react";
import { Input, Select } from "antd";
import { countryCodeOptions } from "constants/countryCodes";

export interface CountryCodeAndPhoneNumber {
    countryCode: number;
    phoneNumber: string;
}

export interface PhoneInputProps {
    value?: CountryCodeAndPhoneNumber;
    onChange?: (value: CountryCodeAndPhoneNumber) => void;
    placeholder?: string;
    size?: "small" | "middle" | "large";
    disabled?: boolean;
    /** 仅禁用手机号输入框，前边区号下拉仍可编辑 */
    phoneNumberDisabled?: boolean;
    readOnly?: boolean;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({ 
    value, 
    onChange, 
    placeholder, 
    size = "middle",
    readOnly = false,
    disabled = false,
    phoneNumberDisabled = false
}) => {
    const [internalValue, setInternalValue] = useState<CountryCodeAndPhoneNumber>({
        countryCode: 1,
        phoneNumber: ""
    });

    useEffect(() => {
        if (value) {
            setInternalValue(value);
        } else {
            // 如果没有value，重置为默认值
            setInternalValue({
                countryCode: 1,
                phoneNumber: ""
            });
        }
    }, [value]);

    // 始终使用Form传递的value，如果没有则使用internalValue
    const currentValue = value !== undefined ? value : internalValue;

    const handleCountryCodeChange = (newCountryCode: number) => {
        const newValue = {
            countryCode: newCountryCode,
            phoneNumber: currentValue.phoneNumber
        };
        
        setInternalValue(newValue);
        onChange?.(newValue);
    };

    const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newPhoneNumber = e.target.value.replace(/[^0-9]/g, '');
        const newValue = {
            countryCode: currentValue.countryCode,
            phoneNumber: newPhoneNumber
        };
        
        setInternalValue(newValue);
        onChange?.(newValue);
    };

    return (
        <div className="flex">
            <Select
                value={currentValue.countryCode}
                onChange={handleCountryCodeChange}
                disabled={disabled}
                size={size}
                style={{ width: 80 }}
                options={countryCodeOptions.map(option => ({
                    label: option.label,
                    value: option.value
                }))}
            />
            <Input
                placeholder={placeholder}
                value={currentValue.phoneNumber}
                onChange={handlePhoneNumberChange}
                readOnly={readOnly}
                disabled={disabled || phoneNumberDisabled}
                size={size}
                style={{ flex: 1 }}
            />
        </div>
    );
};   
